module.exports = __webpack_public_path__ + "img/logo.91dc76bc.png";